import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { t } from "../../locales/translate";
import Logo from "./Images/ShresthaAppsLogo512.png";
import MPCIcon from "./Images/MPCIcon.png";
import LEDIcon from "./Images/LEDIcon.png";
import IDPhotoIcon from "./Images/IDPhotoLogo.webp";
import BudgetPlannerIcon from "./Images/BudgetPlannerIcon.png";
import FamilyMedicineIcon from "./Images/FamilyMedicineIcon.png";
import PaperModeIcon from "./Images/PaperModeIcon.png";
import PujanDP from "./Images/PujanDP.png";
import ManojDP from "./Images/ProfilePic.jpg";
import InfoComponent from "./InfoComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileAlt, faDesktop, faShareAlt } from "@fortawesome/free-solid-svg-icons";

function useLang() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const lang = params.get("lang");
  const supported = ["en", "ja", "ne", "zh", "ko"];
  return supported.includes(lang) ? lang : "en";
}

function useDarkMode() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const darkMode = params.get("dark");
  return darkMode === "true";
}

const portfolioApps = [
  {
    id: 1,
    nameKey: "mpc",
    descriptionKeys: ["desc"],
    icon: (
      <div
        style={{
          background: "#f8e2e6",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
        }}
      >
        <img
          src={MPCIcon}
          alt="MPC Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shrestha.MPC",
    appStoreUrl:
      "https://apps.apple.com/us/app/marriagepointcalculator-mpc/id1599221145",
  },
  {
    id: 2,
    nameKey: "Passport & ID Photo Print",
    descriptionKeys: [
      "Create official passport, visa, and ID photos directly from your smartphone — completely free. Easily crop, adjust, and format your photos to meet official requirements, then print multiple photos on a single sheet without visiting a photo studio.",
      "",
    ],
    icon: (
      <div
        style={{
          background: "#daf2ff",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 60,
        }}
      >
        <img
          src={IDPhotoIcon}
          alt="IDPhoto Print Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shrestha.idphotoprint",
    appStoreUrl:
      "https://apps.apple.com/us/app/passport-id-photo-print/id6757211469",
  },
  {
    id: 5,
    nameKey: "Family Medicine Reminder",
    descriptionKeys: [
      "Never miss a dose. Family Medicine Reminder makes it easy to keep track of daily medicines for yourself and your loved ones.",
      "Manage schedules for parents, kids, or your partner right from your phone. You can set up and adjust reminders remotely, so your family always takes the right medicine on time."
    ],
    icon: (
      <div
        style={{
          background: "#b0f5d3ff",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          src={FamilyMedicineIcon}
          alt="Family Medicine Reminder Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shrestha.medsReminder",
    appStoreUrl:
      "https://apps.apple.com/us/app/family-medicine-reminder/id6759514659",
  },
  {
    id: 3,
    nameKey: "led",
    descriptionKeys: ["desc1", "desc2"],
    icon: (
      <div
        style={{
          background: "#c5dcf5",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 60,
        }}
      >
        <img
          src={LEDIcon}
          alt="LED Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shrestha.ledsignboard",
    appStoreUrl:
      "https://apps.apple.com/jp/app/led-neon-sign-board/id6743044200?l=en-US",
  },
  {
    id: 6,
    nameKey: "Paper Mode Reader",
    descriptionKeys: [
      "Transform your phone into a cozy, E-Ink style reader that reduces eye strain for a comfortable, paper-like reading experience."
    ],
    icon: (
      <div
        style={{
          background: "rgb(247, 228, 184)",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
        }}
      >
        <img
          src={PaperModeIcon}
          alt="Paper Mode Reader Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shresthaapps.papermode",
    appStoreUrl:
      "https://apps.apple.com/us/app/paper-mode-e-ink-style-reader/id6797350443",
  },
  {
    id: 3,
    nameKey: "sib",
    descriptionKeys: ["desc"],
    icon: (
      <div
        style={{
          background: "#e3f2fd",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
        }}
      >
        <img
          src={BudgetPlannerIcon}
          alt="Budget Planner Icon"
          style={{
            width: 84,
            height: 84,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>
    ),
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=com.shrestha.budgetplanner",
    appStoreUrl:
      "https://apps.apple.com/us/app/self-improvement-budget-app/id6757952558",
  },
  {
    id: 4,
    nameKey: "tax",
    descriptionKeys: ["desc"],
    icon: (
      <div
        style={{
          background: "#d5e6f9",
          borderRadius: "50%",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 60,
        }}
      >
        📧
      </div>
    ),
    webUrl: "https://shrestham.com.np/taxadvisor",
  },
];

const floatingCardStyle = {
  background: "var(--sa-bg-primary)",
  borderRadius: "var(--ShresthaApp-border-radius)",
  boxShadow: "var(--sa-card-shadow)",
  transition: "box-shadow 0.3s, transform 0.2s, background-color 0.3s ease",
  position: "relative",
  zIndex: 1,
  willChange: "transform",
  marginBottom: 8,
  cursor: "pointer",
};

function handleCardHover(e) {
  e.currentTarget.style.transform = "translateY(-6px) scale(1.03)";
  e.currentTarget.style.boxShadow =
    "0 16px 48px 0 rgba(31, 41, 55, 0.22), 0 3px 12px 0 rgba(0,0,0,0.10)";
}
function handleCardOut(e) {
  e.currentTarget.style.transform = "none";
  e.currentTarget.style.boxShadow =
    "0 8px 32px 0 rgba(31, 41, 55, 0.18), 0 1.5px 6px 0 rgba(0,0,0,0.07)";
}

const CompanyLogo = () => (
  <div style={{ display: "flex", justifyContent: "center", marginBottom: 32 }}>
    <img
      src={Logo}
      alt="Shrestha Apps Logo"
      style={{
        width: 200,
        height: 200,
        borderRadius: "50%",
        objectFit: "cover",
        background: "white",
        boxShadow: "0 2px 16px 0 rgba(0,0,0,0.08)",
      }}
    />
  </div>
);

const teamMembers = [
  {
    key: "manoj",
    photo: ManojDP,
    link: "https://shrestham.com.np",
  },
  {
    key: "pujan",
    photo: PujanDP,
    link: "https://shresthapujan.com.np",
  },
];

export default function AboutPage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // Get element's position and scroll with increased offset (30px)
        const y = el.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, []);
  const lang = useLang();
  const isDarkMode = useDarkMode();

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "var(--sa-bg-secondary)",
        color: "var(--sa-text-primary)",
        transition: "background-color 0.3s ease, color 0.3s ease",
      }}
    >
      {/* Main Content */}
      <main
        style={{
          flexGrow: 1,
          width: "100%",
          maxWidth: 1200,
          margin: "0 auto",
          padding: "32px 16px",
        }}
      >
        {/* Company Overview */}
        <section style={{ marginBottom: 64 }}>
          <CompanyLogo />
          <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
            <h2
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: "var(--sa-text-primary)",
                marginBottom: 16,
              }}
            >
              {t(lang, ["about", "title"])}
            </h2>
            <p
              style={{
                fontSize: 18,
                color: "var(--sa-text-secondary)",
                lineHeight: 1.7,
                textAlign: "justify",
              }}
            >
              {t(lang, ["about", "desc"]) ||
                "Our mission is to develop seamless, user-friendly free applications that streamline tasks and enhance productivity across multiple platforms. We believe in creating tools that make everyday life easier without compromising on quality or user experience."}
            </p>
          </div>
        </section>

        {/* Portfolio Section */}
        <section style={{ marginBottom: 64 }}>
          <h2
            style={{
              fontSize: 24,
              fontWeight: 700,
              textAlign: "center",
              color: "var(--sa-text-primary)",
              marginBottom: 24,
            }}
          >
            {t(lang, ["about", "portfolio", "title"])}
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: 24,
            }}
          >
            {portfolioApps.map((app, idx) => (
              <div
                key={app.id}
                id={
                  app.nameKey === "mpc" ? "mpc" :
                  app.nameKey === "led" ? "led" :
                  app.nameKey === "Family Medicine Reminder" ? "medicine" :
                  app.nameKey === "Passport & ID Photo Print" ? "idphoto" :
                  app.nameKey === "Paper Mode Reader" ? "papermode" :
                  app.nameKey === "sib" ? "sib" :
                  app.nameKey === "tax" ? "tax" : 
                  `app-${app.id}`
                }
                style={{
                  ...floatingCardStyle,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: 32,
                  overflow: "hidden",
                }}
                onMouseOver={handleCardHover}
                onMouseOut={handleCardOut}
              >
                {idx === 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #FF416C 0%, #FF4B2B 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 12,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    100k+ Downloads
                  </div>
                )}
                {idx === 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 12,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    Saves Your Money
                  </div>
                )}
                {idx === 2 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 12,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    Brand New
                  </div>
                )}
                {idx === 3 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #ffe259 0%, #ffa751 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 11,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    Birthdays & Concerts
                  </div>
                )}
                {idx === 4 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 12,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    Brand New
                  </div>
                )}
                {idx === 5 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 44,
                      left: -74,
                      width: 260,
                      textAlign: "center",
                      background: "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)",
                      color: "white",
                      padding: "6px 0",
                      fontSize: 11,
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      transform: "rotate(-45deg)",
                      zIndex: 10,
                    }}
                  >
                    Investment Planning
                  </div>
                )}
                {app.icon}
                <div
                  style={{
                    fontSize: 20,
                    marginTop: 16,
                    fontWeight: 600,
                    color: "var(--sa-text-primary)",
                  }}
                >
                  {t(lang, ["about", "portfolio", app.nameKey, "name"]) ||
                    app.nameKey}
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "var(--sa-text-tertiary)",
                    marginTop: 8,
                  }}
                >
                  {app.descriptionKeys.map((descKey, i) => (
                    <div key={descKey} style={i > 0 ? { marginTop: 8 } : {}}>
                      {t(lang, ["about", "portfolio", app.nameKey, descKey]) ||
                        descKey}
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 24,
                    width: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {/* Buttons for Play Store, App Store, Web */}
                    {(app.playStoreUrl || app.appStoreUrl) && (
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          width: "100%",
                          marginTop: 8,
                        }}
                      >
                        <button
                          style={{
                            flex: 1,
                            padding: "8px 4px",
                            fontSize: "0.85rem",
                            backgroundColor: "var(--sa-button-primary)",
                            color: "white",
                            border: "none",
                            borderRadius: "var(--ShresthaApp-border-radius)",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background-color 0.3s ease",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          onClick={() => {
                            const ua =
                              navigator.userAgent ||
                              navigator.vendor ||
                              window.opera;
                            const isAndroid = /android/i.test(ua);
                            const isApple =
                              /iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(ua) ||
                              (navigator.platform &&
                                /Mac/i.test(navigator.platform));

                            if (isAndroid && app.playStoreUrl) {
                              window.open(
                                app.playStoreUrl,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            } else if (isApple && app.appStoreUrl) {
                              window.open(
                                app.appStoreUrl,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            } else if (app.playStoreUrl) {
                              window.open(
                                app.playStoreUrl,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            } else if (app.appStoreUrl) {
                              window.open(
                                app.appStoreUrl,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            }
                          }}
                          aria-label={t(lang, [
                            "about",
                            "portfolio",
                            "installOnMobile",
                          ])}
                        >
                          <FontAwesomeIcon
                            icon={faMobileAlt}
                            style={{ marginRight: 8, fontSize: 15 }}
                          />
                          {t(lang, ["about", "portfolio", "installOnMobile"])}
                        </button>
                        <button
                          style={{
                            flex: 1,
                            padding: "8px 4px",
                            fontSize: "0.85rem",
                            backgroundColor: "var(--sa-button-secondary)",
                            color: "white",
                            border: "none",
                            borderRadius: "var(--ShresthaApp-border-radius)",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background-color 0.3s ease",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          onClick={() => {
                            const redirectUrl = `${window.location.origin}/sa/redirect?android=${encodeURIComponent(app.playStoreUrl || "")}&ios=${encodeURIComponent(app.appStoreUrl || "")}`;
                            const sharePageUrl = `${window.location.origin}/sa/shareapp?url=${encodeURIComponent(redirectUrl)}&lang=${lang}&dark=${isDarkMode}`;
                            window.open(
                              sharePageUrl,
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }}
                          aria-label={t(lang, ["share", "title"])}
                        >
                          <FontAwesomeIcon
                            icon={faShareAlt}
                            style={{ marginRight: 8, fontSize: 13 }}
                          />
                          {t(lang, ["share", "title"])}
                        </button>
                      </div>
                    )}
                    {app.webUrl && (
                      <button
                        style={{
                          width: "100%",
                          marginTop: 8,
                          padding: "8px 8px",
                          backgroundColor: "var(--sa-button-primary)",
                          color: "white",
                          border: "none",
                          borderRadius: "var(--ShresthaApp-border-radius)",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "background-color 0.3s ease",
                        }}
                        onClick={() =>
                          window.open(
                            app.webUrl,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                        aria-label={t(lang, [
                          "about",
                          "portfolio",
                          "openWebApp",
                        ])}
                      >
                        <FontAwesomeIcon
                          icon={faDesktop}
                          className="text-xl"
                          style={{ marginRight: 8, fontSize: 13 }}
                        />
                        {t(lang, ["about", "portfolio", "openWebApp"])}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Team Section */}
        <section>
          <h2
            style={{
              fontSize: 24,
              fontWeight: 700,
              textAlign: "center",
              color: "var(--sa-text-primary)",
              marginBottom: 24,
            }}
          >
            {t(lang, ["about", "team", "title"])}
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: 24,
            }}
          >
            {teamMembers.map((member, idx) => (
              <div
                key={member.key}
                style={{
                  ...floatingCardStyle,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: 32,
                }}
                onMouseOver={handleCardHover}
                onMouseOut={handleCardOut}
              >
                <img
                  src={member.photo}
                  alt={
                    t(lang, ["about", "team", member.key, "name"]) || member.key
                  }
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginBottom: 16,
                  }}
                />
                <h3
                  style={{
                    fontSize: 20,
                    fontWeight: 600,
                    marginBottom: 4,
                    color: "var(--sa-text-primary)",
                  }}
                >
                  {t(lang, ["about", "team", member.key, "name"]) || member.key}
                </h3>
                <p
                  style={{ color: "var(--sa-text-tertiary)", marginBottom: 16 }}
                >
                  {t(lang, ["about", "team", member.key, "role"]) || ""}
                </p>
                <p
                  style={{
                    color: "var(--sa-text-secondary)",
                    textAlign: "justify",
                  }}
                >
                  {t(lang, ["about", "team", member.key, "desc"]) || ""}
                </p>
                <a
                  href={member.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: "100%", display: "block" }}
                >
                  <button
                    style={{
                      marginTop: 12,
                      padding: "8px 20px",
                      backgroundColor: "var(--sa-button-secondary)",
                      color: "white",
                      border: "none",
                      borderRadius: "var(--ShresthaApp-border-radius)",
                      fontWeight: 500,
                      letterSpacing: 0.5,
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                      width: "100%",
                    }}
                  >
                    {t(lang, ["about", "team", member.key, "profile"]) ||
                      t(lang, ["about", "team", "learnMore"]) ||
                      "Learn More"}
                  </button>
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>
      {/* Footer */}
      <InfoComponent />
    </div>
  );
}
